import React from "react";

const MainFooter = () => {
  return (
    <footer className="flex items-center justify-between border-t border-[#e5e5e7]/60 bg-white/60 px-5 py-3 backdrop-blur-sm">
      <span className="text-[12px] font-medium tracking-[-0.01em] text-[#86868b]">
        ©2025 <span className="font-semibold text-[#1d1d1f]">egaranti</span>
      </span>
    </footer>
  );
};

export default MainFooter;
